import "@videojs/html/video/player";
import "@videojs/html/video/minimal-skin";
import autoAddBlurs from "./components/ElementBlurs";
import { autoInitGlowingVideos } from "./components/GlowingVideo";
import { autoInitGradients } from "./components/GradientGlow";
import { autoInitChromaticImages } from "./components/ChromaticImages";
import initAllLightboxTargets from "./components/lightbox/Lightbox";
import initFrontPage from "./pages/font-page";
import initScrollAnimation from "./components/scroll-animations";
import initLeafletMaps from "./components/maps/map";
import initHeader from "./components/header";
autoInitGlowingVideos();
autoAddBlurs();
autoInitGradients();
initHeader();
const navigationCallbacks = [initFrontPage];
const navigatePerPage = [
    initAllLightboxTargets,
    autoInitChromaticImages,
    initScrollAnimation,
    initLeafletMaps,
];
navigationCallbacks.forEach((fn, index) => {
    window.addNavigationCallback(fn, `fn-${index}`);
});
navigatePerPage.forEach((fn, index) => {
    var _a;
    const pageIdContainer = document.querySelector("[data-p-id]");
    const pageId = (_a = pageIdContainer === null || pageIdContainer === void 0 ? void 0 : pageIdContainer.dataset) === null || _a === void 0 ? void 0 : _a.pId;
    window.addNavigationCallback(fn, `pp-fn-${index}-${pageId}`);
});
